<div class="stick-top">
  <mat-toolbar><mat-icon>groups</mat-icon> Contact Groups</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/contactGroups/0">
      <mat-icon aria-label="Create a new contact group">groups</mat-icon>
      Create a new Contact Group
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th *ngIf="isCompanyAdmin">
        <div class="vbox">
          Company
          <micro-company-select [(companyId)]="filter.companyId" [disabled]="auth.companyIdFilter"></micro-company-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Name
          <input [(ngModel)]="filter.name">
        </div>
      </th>
      <th class="align-top">
        <div class="vbox">
          Group Members
        </div>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td *ngIf="isCompanyAdmin">
        <micro-company-lookup [companyId]="element.companyId" [link]="!filter.companyId"></micro-company-lookup>
      </td>
      <td><a routerLink="/contactGroups/{{element.id}}">{{element.name}}</a></td>
      <td class="text-right">{{element.members?.length}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0">
      <td colspan="100"><em>No results found</em></td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
